import { scrollbarStyles } from "@ecco/ui/css/scrollbar";

export const styles: { [x: string]: { [y: string]: any } } = {
    button: {
        w: ["100%", "100%"],
        WebkitTapHighlightColor: "transparent",
        _hover: {
            bg: "transparent",
        },
        _active: {
            bg: "transparent",
        },
        justifyContent: "space-between",
        px: 6,
    },
    modalCloseButton: {
        background: "gray.50",
        WebkitTapHighlightColor: "transparent",
        _active: {
            outline: "none",
        },
        _focus: {
            outline: "none",
        },
        _hover: {
            bg: "gray.50",
        },
    },
    modalContent: {
        WebkitTapHighlightColor: "transparent",
        overflowY: "auto",
        ...scrollbarStyles,
    },
    wrapContainer: {
        pt: 12,
        flexDirection: "column",
        justifyContent: "center",
        gap: 3,
    },
    wrapItem: {
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        borderColor: "gray.100",
        px: 4,
        py: 2,
        _focus: {
            border: "none",
            bg: "white",
        },
        _focusVisible: {
            border: "none",
            bg: "white",
        },
    },
};
